import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Don't retry auth/permission errors
        if (error instanceof Error && error.message.includes('401')) return false;
        if (error instanceof Error && error.message.includes('403')) return false;
        if (error instanceof Error && error.message.includes('429')) return false;
        // API still starting (Vite proxy ECONNREFUSED) or brief network blip
        if (error instanceof TypeError) return failureCount < 3;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});
